// i18n.ts
import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import ptBrTranslation from "../locales/pt-BR.json";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "pt-BR", // Defina o idioma para pt-BR
    fallbackLng: "pt-BR", // O idioma de fallback também é pt-BR
    debug: true,
    resources: {
      "pt-BR": {
        translation: ptBrTranslation,
      },
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
